import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, BehaviorSubject } from 'rxjs';



@Injectable({
  providedIn: 'root'
})

export class ApiService {

  private messageSource = new BehaviorSubject('keine Query');
  currentMessage = this.messageSource.asObservable();
  allIds: any;
  body: any;
  bodyAllIds: any;
  bodySearch: any;

  constructor(
    private http: HttpClient) {
  }


  changeMessage(message: string) {
    this.messageSource.next(message);
  }

  Search(body: any): Observable<any> {
    console.log(body);
    return this.http.post(environment.wordpressThemeUrl + environment.searchUrl, body);
  }

  getDocument(id: any | any[]): any {
    let proxyBody;
    // Check if 'id' is an array and construct the query accordingly
    if (Array.isArray(id)) {
      // If 'id' is an array, use the 'ids' query
      proxyBody = {
        'query': {
          'ids': {
            'values': id // 'id' is an array of document IDs
          }
        }
      };
    } else {
      // If 'id' is not an array, use the 'term' query to search for a single ID
      proxyBody = {
        'query': {
          'term': {
            '_id': id // 'id' is a single document ID
          }
        }
      };
    }

    console.log(proxyBody);
    return this.http.post(environment.wordpressThemeUrl + environment.searchUrl, proxyBody);
  }


  getMinMax() {
    return this.http.post(environment.wordpressThemeUrl + environment.searchUrl, {
      "aggs": {
        "min_range_geburt": {
          "min": {
            "field": "range_geburt"
          }
        },
        "max_range_geburt": {
          "max": {
            "field": "range_geburt"
          }
        }
      }
    });
  }

  getAnalyse(id: any): any {
    const proxyBody = {
      'query': {
        'multi_match': {
          'query': id,
          'fields': ['_id']
        }
      }
    };
    return this.http.post(environment.wordpressThemeUrl + environment.analyseUrl, proxyBody);
  }

  getMapping() {
    return this.http.get(environment.wordpressThemeUrl + '/assets/json/mapping.json');
  }
}
